import Assets from './Assets/Assets';
import PersonalDetails from './PersonalDetails/PersonalDetails';
import Expenditure from './Expenditure/Expenditure';
import Employment from './Employment/Employment';
import Pensions from './Pensions/Pensions';
import Income from './Income/Income';
import Vulnerabilities from './Vulnerabilities/Vulnerabilities';

const exportObject = {
  PersonalDetails,
  Assets,
  Expenditure,
  Employment,
  Pensions,
  Income,
  Vulnerabilities,
};

export default exportObject;
